<template>
  <a-button
    type="primary"
    size="small"
    @click.stop="() => handleOpenEdit(record)"
    v-if="record.is_active && titleList.is_update && !column_dropdown_btn_dict"
  >
    修改
  </a-button>
  <a-button
    v-for="btn in column_normal_btn_list"
    size="small"
    v-show="btn?.is_show ? btn.is_show(record) : true"
    :disabled="btn?.disabled ? btn?.disabled(record) : false"
    :key="btn.name"
    :type="btn.clazz"
    @click.stop="btn.cb(record, dataSource, index, requestParams)"
  >
    {{ btn.name }}
  </a-button>
  <a-button
    size="small"
    type="danger"
    @click.stop="() => handleDelete(record)"
    v-if="record.is_active && titleList.is_remove && !column_dropdown_btn_dict"
  >
    {{ titleList.del_btn ? titleList.del_btn : '禁用' }}
  </a-button>

  <a-button
    size="small"
    type="dashed"
    @click.stop="() => handleRecover(record)"
    v-if="!record.is_active && titleList.is_recover && !column_dropdown_btn_dict"
  >
    恢复
  </a-button>
  <template v-if="column_dropdown_btn_dict">
    <a-dropdown-button size="small">
      <a-button
        type="link"
        @click.stop="
          column_dropdown_btn_dict.dropdown_btn.cb(record, dataSource, index, requestParams)
        "
        size="small"
        :disabled="
          column_dropdown_btn_dict.dropdown_btn?.is_show
            ? !column_dropdown_btn_dict.dropdown_btn.is_show(record)
            : false
        "
      >
        <span
          :style="
            column_dropdown_btn_dict.dropdown_btn.style &&
            column_dropdown_btn_dict.dropdown_btn.style(record)
          "
        >
          {{ column_dropdown_btn_dict.dropdown_btn.name }}
        </span>
      </a-button>
      <template #overlay>
        <a-menu>
          <a-menu-item
            :key="btn.name"
            :disabled="btn?.is_show ? !btn.is_show(record) : false"
            @click.stop="btn.cb(record, dataSource, index, requestParams)"
            v-for="btn in column_dropdown_btn_dict.btn_list"
          >
            {{ btn.name }}
          </a-menu-item>

          <a-menu-item
            key="update"
            v-if="record.is_active && titleList.is_update"
            @click.stop="handleOpenEdit(record)"
          >
            <edit-outlined />
            修改
          </a-menu-item>
          <a-menu-item
            key="update"
            v-if="record.is_active && titleList.is_remove"
            @click.stop="handleDelete(record)"
          >
            <delete-outlined />
            禁用
          </a-menu-item>
          <a-menu-item
            key="update"
            v-if="!record.is_active && titleList.is_recover"
            @click.stop="handleRecover(record)"
          >
            <redo-outlined />
            恢复
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown-button>
  </template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Cell_action',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: false,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
    dataSource: {
      type: Array,
      required: false,
      default: () => [],
    },
    titleList: {
      type: Object,
      required: true,
      default: () => {},
    },
    column_dropdown_btn_dict: {
      type: Object,
      required: false,
      default: () => {},
    },
    column_normal_btn_list: {
      type: Array,
      required: true,
      default: () => [],
    },
    handleOpenEdit: {
      type: Function,
      required: true,
    },
    handleDelete: {
      type: Function,
      required: true,
    },
    handleRecover: {
      type: Function,
      required: true,
    },
    requestParams: {
      type: Object,
      required: false,
    },
  },
});
</script>
<style lang="less">
.needCopyRow {
  td {
    position: relative;
  }
}
.large-font {
  font-weight: 500;
  font-size: 17px;
}
.large-number-font {
  font-weight: 500;
  font-size: 24px;
}
</style>
